<template>
<div class="input__wrapper">
   <input type="text" class="input__text" v-model="imageSrc" placeholder="image source">
    <DeleteButton :index="index" />
</div> 
</template>

<script setup>
import DeleteButton from '@/components/PopUp/DeleteButton.vue'
import { fieldFactory } from '@/helper/popFieldFactory';
const props = defineProps({
    popStoreId:String,
    index:Number
})

const imageSrc = fieldFactory('imageSrc', props.popStoreId)
</script>

<style>

</style>